// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// assets
import maleIcon from "../../../assets/respondentDashboard/male-icon.png";
import maleColorIcon from "../../../assets/respondentDashboard/male-color-icon.png";
import femaleIcon from "../../../assets/respondentDashboard/female-icon.png";
import femaleColorIcon from "../../../assets/respondentDashboard/female-color-icon.png";
import nonBinaryIcon from "../../../assets/respondentDashboard/nonBinaryIcon.png";
import nonBinaryColorIcon from "../../../assets/respondentDashboard/nonBinaryColorIcon.png";
// import Others from "../../../assets/respondentDashboard/Others.png";
// import OthersColorIcon from "../../../assets/respondentDashboard/OthersColorIcon.png";
import preferNotToSay from "../../../assets/respondentDashboard/preferNotToSay.png";
import preferNotToSayColorIcon from "../../../assets/respondentDashboard/preferNotToSayColorIcon.png";
import OthersIconNeuColor from "../../../assets/respondentDashboard/OthersIconNeuColor.png";
import OthersIconNeu from "../../../assets/respondentDashboard/OthersIconNeu.png";

function PersonFill({ graphData = {} }) {
    // const answersObject = genderData?.answers || {};
    const finalArr = Object.keys(graphData).map((key) => ({
        name: key,
        percentage: graphData[key].percentage,
        count: graphData[key].sample_size,
    }));
    const reversedArray = [...finalArr].reverse();
    // const getStatsForName = (name) => {
    //     const stats = statsData.find((item) => item.title === name);
    //     return stats || { mean: 0, median: 0, std_dev: 0 };
    // };

    const renderIcon = (name, percentage, count) => {
        // const { mean, median, std_dev } = getStatsForName(name);
        switch (name) {
            case "Male":
                return (
                    <div key={name}>
                        <style>
                            {`
                                .male-icon {
                                    width: 80px;
                                    height: 150px;
                                    display: inline-block;
                                    position: relative;
                                    background: url(${maleIcon}) no-repeat left bottom;
                                    background-size: cover;
                                    transition: transform 0.3s;
                                    cursor:pointer;
                                    z-index: 1;
                                }
                                .male-icon span {
                                    width: 100%;
                                    height: 0;
                                    display: inline-block;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    background: url(${maleColorIcon}) no-repeat left bottom;
                                    background-size: cover;
                                }
                                .male-icon:hover{
                                    transform:scale(1.2);
                                    z-index:3;
                                }
                                .label-container-male{
                                    color:#808080;
                                    width:110px;
                                    border:1px  solid;
                                    border-radius:5px;                                   
                                    border-color: #3DD0FF;
                                    background-color:#ffffff;
                                    text-align:left;
                                    padding:5px;
                                    margin-left:80px;
                                    visibility:hidden;
                                    opacity:0;
                                    transition:opacity 0.5s ease;
                                    z-index:4;
                                }
                                .male-icon:hover .label-container-male{
                                    visibility:visible;
                                    opacity:1;
                                }
                            `}
                        </style>
                        <div style={{ margin: "10px" }}>
                            <span className="male-icon">
                                <span style={{ height: `${percentage}%` }}></span>
                                <div className="label-container-male">
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        {name} : {count}
                                    </p>
                                    {/* <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Mean : {mean}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Std Dev : {std_dev}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Median : {median}
                                    </p> */}
                                </div>
                            </span>
                            <div>
                                <p style={{ fontSize: "14px", margin: "4px" }}>{name}</p>
                                <p
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        color: "#3DD0FF",
                                    }}
                                >
                                    {Math.round(percentage)}%
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case "Female":
                return (
                    <div key={name}>
                        <style>
                            {`
                                .female-icon {
                                    width: 80px;
                                    height: 150px;
                                    display: inline-block;
                                    position: relative;
                                    background: url(${femaleIcon}) no-repeat left bottom;
                                    background-size: cover;
                                    transition: transform 0.3s;
                                    cursor:pointer;
                                    z-index: 1;
                                }
                                .female-icon span {
                                    width: 100%;
                                    height: 0;
                                    display: inline-block;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    background: url(${femaleColorIcon}) no-repeat left bottom;
                                    background-size: cover;
                                }
                                .female-icon:hover{
                                    transform:scale(1.2);
                                    z-index:3;
                                }
                                .label-container-female{
                                    color:#808080;
                                    width:110px;
                                    border:1px  solid;
                                    border-radius:5px;
                                    background-color:#ffffff;
                                    border-color:#F185D2;
                                    text-align:left;
                                    padding:5px;
                                    margin-left:80px;
                                    visibility:hidden;
                                    opacity:0;
                                    transition:opacity 0.5s ease;
                                    z-index:4;
                                }
                                .female-icon:hover .label-container-female{
                                    visibility:visible;
                                    opacity:1;
                                }
                                 
                            `}
                        </style>
                        <div style={{ margin: "10px" }}>
                            <span className="female-icon">
                                <span style={{ height: `${percentage}%` }}></span>
                                <div className="label-container-female">
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        {name} : {count}
                                    </p>{" "}
                                    {/* <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Mean : {mean}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Std Dev : {std_dev}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Median : {median}
                                    </p> */}
                                </div>
                            </span>
                            <div>
                                <p style={{ fontSize: "14px", margin: "4px" }}>{name}</p>
                                <p
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        color: "#F185D2",
                                    }}
                                >
                                    {Math.round(percentage)}%
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case "Non-binary":
                return (
                    <div key={name}>
                        <style>
                            {`
                                .non-binary-icon {
                                    width: 80px;
                                    height: 150px;
                                    display: inline-block;
                                    position: relative;
                                    background: url(${nonBinaryIcon}) no-repeat left bottom;
                                    background-size: cover;
                                    transition: transform 0.3s;
                                    cursor:pointer;
                                    z-index: 1;
                                }
                                .non-binary-icon span {
                                    width: 100%;
                                    height: 0;
                                    display: inline-block;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    background: url(${nonBinaryColorIcon}) no-repeat left bottom;
                                    background-size: cover;
                                }
                                 .non-binary-icon:hover{
                                    transform:scale(1.2);
                                    z-index:3;
                                }
                                .label-container-non{
                                    color:#808080;
                                    background-color:#fff;
                                    width:110px;
                                    border:1px  solid;
                                    border-radius:5px;
                                    background-color:#ffffff;
                                    border-color:#FFA91F;
                                    text-align:left;
                                    padding:5px;
                                    margin-left:80px;
                                    visibility:hidden;
                                    opacity:0;
                                    transition:opacity 0.5s ease;
                                    z-index:4;
                                }
                                .non-binary-icon:hover .label-container-non{
                                    visibility:visible;
                                    opacity:1;
                                }
                            `}
                        </style>
                        <div style={{ margin: "10px" }}>
                            <span className="non-binary-icon">
                                <span style={{ height: `${percentage}%` }}></span>
                                <div className="label-container-non">
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        {name} : {count}
                                    </p>{" "}
                                    {/* <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Mean : {mean}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Std Dev : {std_dev}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Median : {median}
                                    </p> */}
                                </div>
                            </span>
                            <div>
                                <p style={{ fontSize: "14px", margin: "4px" }}>{name}</p>
                                <p
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        color: "#FFA91F",
                                    }}
                                >
                                    {Math.round(percentage)}%
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case "Others":
                return (
                    <div key={name}>
                        <style>
                            {`
                                .others-icon {
                                    width: 75px;
                                    height: 150px;
                                    display: inline-block;
                                    position: relative;
                                    background: url(${OthersIconNeu}) no-repeat left bottom;
                                    background-size: cover;
                                    transition: transform 0.3s;
                                    cursor:pointer;
                                    z-index: 1;
                                    margin-bottom:10px;
                                }
                                .others-icon span {
                                    width: 100%;
                                    height: 0;
                                    display: inline-block;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    background: url(${OthersIconNeuColor}) no-repeat left bottom;
                                    background-size: cover;
                                }
                                .others-icon:hover{
                                    transform: scale(1.2);
                                    z-index:3;
                                }
                                .label-container-others{
                                    color:#808080;
                                    width:110px;
                                    border:1px  solid;
                                    border-radius:5px;
                                    border-color: #008323;
                                    text-align:left;
                                    background-color:#ffffff;
                                    padding:5px;
                                    margin-left:90px;
                                    visibility:hidden;
                                    transform: translateX(-10%);
                                    opacity:0;
                                    transition:opacity 0.5s ease;
                                    z-index:4;
                                }
                                .others-icon:hover .label-container-others{
                                    visibility:visible;
                                    opacity:1;
                                }
                            `}
                        </style>
                        <div style={{ margin: "0px 10px 10px 10px" }}>
                            <span className="others-icon">
                                <span style={{ height: `${percentage}%` }}></span>
                                <div className="label-container-others">
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        {name} : {count}
                                    </p>{" "}
                                    {/* <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Mean : {mean}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Std Dev : {std_dev}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Median : {median}
                                    </p> */}
                                </div>
                            </span>
                            <div>
                                <p style={{ fontSize: "14px", margin: "4px" }}>{name}</p>
                                <p
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        color: "#008323",
                                    }}
                                >
                                    {Math.round(percentage)}%
                                </p>
                            </div>
                        </div>
                    </div>
                );
            case "Prefer not to say":
                return (
                    <div key={name}>
                        <style>
                            {`
                                .prefer-not-to-say-icon {
                                    width: 72px;
                                    height: 150px;
                                    display: inline-block;
                                    position: relative;
                                    background: url(${preferNotToSay}) no-repeat left bottom;
                                    background-size: cover;
                                    transition: transform 0.3s;
                                    cursor:pointer;
                                    z-index: 1;
                                    margin-bottom:10px;
                                }
                                .prefer-not-to-say-icon span {
                                    width: 103%;
                                    height: 0;
                                    display: inline-block;
                                    position: absolute;
                                    left: 0;
                                    bottom: 0;
                                    background: url(${preferNotToSayColorIcon}) no-repeat left bottom;
                                    background-size: cover;
                                }
                                .prefer-not-to-say-icon:hover{
                                    transform:scale(1.2);
                                    z-index:3;
                                }
                                .label-container-prefer{
                                    color:#808080;
                                    width:120px;
                                    border:1px  solid;
                                    border-radius:5px;
                                    border-color: #F40707;
                                    text-align:left;
                                    padding:5px;
                                    margin-left:80px;
                                    transform: translateX(-170%);
                                    visibility:hidden;
                                    background-color:#ffffff;
                                    opacity:0;
                                    transition:opacity 0.5s ease;
                                    z-index:4;
                                }
                                .prefer-not-to-say-icon:hover .label-container-prefer{
                                    visibility:visible;
                                    opacity:1;
                                }
                            `}
                        </style>
                        <div style={{ margin: "0px 10px 10px 10px" }}>
                            <span className="prefer-not-to-say-icon">
                                <span style={{ height: `${percentage}%` }}></span>
                                <div className="label-container-prefer">
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        {name} : {count}
                                    </p>{" "}
                                    {/* <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Mean : {mean}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Std Dev : {std_dev}
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "10px",
                                            margin: "2px 0px",
                                        }}
                                    >
                                        Median : {median}
                                    </p> */}
                                </div>
                            </span>
                            <div>
                                <p style={{ fontSize: "14px", margin: "4px" }}>{name}</p>
                                <p
                                    style={{
                                        fontSize: "20px",
                                        fontWeight: "bold",
                                        color: "#F40707",
                                    }}
                                >
                                    {Math.round(percentage)}%
                                </p>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
            {reversedArray.map(({ name, percentage, count }) => (
                <>{renderIcon(name, percentage, count)}</>
            ))}
        </div>
    );
}

// Typechecking props for the PersonFill
PersonFill.propTypes = {
    graphData: PropTypes.object,
    statsData: PropTypes.array,
};

export default PersonFill;
